import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {UtilService} from 'src/app/services/util.service';
import {PermissionService} from '../../../../services/permission.service';

@Component({
  selector: 'app-device-details-positions',
  templateUrl: './device-details-positions.component.html',
  styleUrls: ['./device-details-positions.component.scss'],
  standalone: false,
})
export class DeviceDetailsPositionsComponent implements OnInit {
  deviceId: number;

  constructor(
    private activatedRoute: ActivatedRoute,
    public util: UtilService,
    public permissionService: PermissionService
  ) {
    this.deviceId = null;
  }

  ngOnInit(): void {
    this.activatedRoute.parent.params.subscribe(params => {
      this.deviceId = +params.deviceID;
    });
  }
}
